import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InViewportDirective } from './directive/in-viewport.directive';
import { ClickOutsideDirective } from './directive/click-outside.directive';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NoWhitespaceDirective } from './directive/no-whitespace.directive';
import { OnlyAlphabetsDirective } from './directive/only-alphabets.directive';
const MODULES = [CommonModule, RouterModule, ReactiveFormsModule, FormsModule];
const DIRECTIVE = [InViewportDirective, ClickOutsideDirective,NoWhitespaceDirective,OnlyAlphabetsDirective];
@NgModule({
  declarations: [...DIRECTIVE],
  imports: [...MODULES,NgMultiSelectDropDownModule.forRoot()],
  exports: [...MODULES, ...DIRECTIVE,NgMultiSelectDropDownModule],
})
export class SharedModule {}
